import { ChartData } from "../../componentTypes/charts";
import { Tooltip } from "../Tooltip";

import * as theme from "./StackedBarChart.css";

export interface StackedBarChartProps<T> {
    data: Array<ChartData<T>>;
    standardColor: string;
    getActivitiesByStatusUrl?: (statusKey: T | null) => string;
}

export function StackedBarChart<T>({
    data,
    standardColor,
    getActivitiesByStatusUrl,
}: StackedBarChartProps<T>) {
    const generateLabel = (entry: ChartData<T>) => {
        return `${entry.label}: ${entry.value}`;
    };

    const getBarStyle = (entry: ChartData<T>) => ({
        flex: `${entry.value} 0 auto`,
        backgroundColor: entry.color || standardColor,
    });

    return (
        <div className={theme.stackedBar}>
            {data.map((entry) => {
                return (
                    <Tooltip
                        title={generateLabel(entry)}
                        key={entry.label}
                        noWrapper
                    >
                        {getActivitiesByStatusUrl &&
                        entry.statusKey !== null ? (
                            <a
                                href={getActivitiesByStatusUrl(entry.statusKey)}
                                style={getBarStyle(entry)}
                            />
                        ) : (
                            <span
                                style={getBarStyle(entry)}
                                className={theme.disabledCursor}
                            />
                        )}
                    </Tooltip>
                );
            })}
        </div>
    );
}
